import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetFullURL } from "./../../../CommonComponents/GlobalConfFiles/URLs";
import { useFetch } from "../../../hooks/useFetch";
import { useMessage } from "../../../hooks/UseMessage";
import OverviewInput from "../../../CommonComponents/InitialInput/OverviewInput"
import OverviewButtons from "./Components/OverviewButtons";
import { LoadingScreen } from "../../../CommonComponents/LoadingScreen/index";
import ListModal from "../../../CommonComponents/Modal/DropDownModal/DropDownListMUI";
import CircleButton from "../../../CommonComponents/CircleButton";
import MessageLog from "../../../CommonComponents/Messages/MessageLog";
import cardlogo from "../../../Assets/cardLogo.svg";

function VehicleOverview() {
  let navigate = useNavigate();

  const [vehicle, setVehicle] = useState();
  const [showVehicleList, setShowVehicleList] = useState(false);
  const [_createErrorMessage, _errorMessages, _setErorMessages] = useMessage();

  const [_getVehicleList, _vehicleList, , , , , , _loadingtVehicleList] =
    useFetch(GetFullURL("VehicleList"), { method: "POST" });

  const [_getVehicleExists, , , , , , , _loadingtVehicleExist] = useFetch(
    GetFullURL("VehicleExist"),
    { method: "POST" }
  );

  function clearMessages(e) {
    e.stopPropagation();
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        break;
      case "error":
        _setErorMessages([]);
        break;
      case "warning":
      default:
        break;
    }
  }
  const operationLoading = _loadingtVehicleExist || _loadingtVehicleList;
  return (
    <section className="heroCard heroPartner">
      {operationLoading && <LoadingScreen />}
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="cardHeader">
                <h2>
                  <span>
                  <img src={require("../../../Assets/icon/vehicle.png")} className="img-fluid cardLogo" alt="" />
                  </span>
                  Vehicle Overview
                </h2>
              </div>
              <div className="cardBody">
                <div className="cardInput">
                  <OverviewInput
                    setDocument={setVehicle}
                    document={vehicle}
                    placeholder="Vehicle id here..."
                  />
                </div>
                <div className="cardButton">
                  <CircleButton
                    buttonText={`List of Vehicles`}
                    clickHandler={() => {
                      _getVehicleList({}, () => {
                        setShowVehicleList(true);
                      });
                    }}
                  />
                  <OverviewButtons
                    vehicle={vehicle}
                    navigate={navigate}
                    _getVehicleExists={_getVehicleExists}
                    _createErrorMessage={_createErrorMessage}
                  />
                </div>
              </div>
            </div>
            <MessageLog
              errorMessages={[..._errorMessages]}
              successMessages={[]}
              warningMessages={[]}
              clearMessages={clearMessages}
            ></MessageLog>
            <div className="cardAlert">
              <ListModal
                setId={setVehicle}
                dataList={_vehicleList}
                showListModal={showVehicleList}
                setShowModal={setShowVehicleList}
                title="List Of Vehicles"
                columns={[
                  { field: "id", headerName: "Vehicle ID", width: 100 },
                  { field: "vehicleTypeId", headerName: "Vehicle Type", width: 250 },
                  { field: "make", headerName: "Make", width: 350 },
                  { field: "fleet", headerName: "Fleet", width: 350 },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VehicleOverview;
